import { Box } from '@mui/material';
import { KitButton } from '../common/MobileKit';
import { protoIcon } from '../common/ProtoIcon';
import { KitAccordion, KitFormBar, KitGrid2, KitInputIco, KitField, KitSeg } from '../common/MobileKitExtras';
import FkField from '../common/MobileFormFields';

/**
 * Formulário de fornecedor no shell mobile — `prototipos-mobile/fornecedores/form.html`.
 * Só apresentação: valores, validação (Yup/Formik), CEP e envio vêm de `pages/suppliers/Form.js`.
 */

const MailIcon = protoIcon('mail');
const PhoneIcon = protoIcon('phone');
const PinIcon = protoIcon('pin');

export default function MobileSupplierForm({
    formik,
    isPJ,
    onPersonTypeChange,
    onDocumentChange,
    onCepChange,
    cepStatus,
    addressOpen,
    onToggleAddress,
    onCancel,
    loading,
}) {
    return (
        <Box sx={{ fontSize: 14, lineHeight: 1.4 }} component="form" onSubmit={formik.handleSubmit} noValidate>
            <KitField label="Tipo de fornecedor" required>
                <KitSeg
                    options={[{ value: 'PJ', label: 'Pessoa Jurídica' }, { value: 'PF', label: 'Pessoa Física' }]}
                    value={isPJ ? 'PJ' : 'PF'}
                    onChange={onPersonTypeChange}
                />
            </KitField>

            <FkField formik={formik} name="legal_name" label={isPJ ? 'Razão social' : 'Nome completo'} required type="text" />
            {isPJ && <FkField formik={formik} name="trade_name" label="Nome fantasia" required type="text" />}
            {isPJ ? (
                <FkField
                    formik={formik}
                    name="document"
                    label="CNPJ"
                    required
                    type="text"
                    placeholder="00.000.000/0001-00"
                    onChange={onDocumentChange}
                />
            ) : (
                <FkField
                    formik={formik}
                    name="document"
                    label="CPF"
                    required
                    type="text"
                    inputMode="numeric"
                    placeholder="000.000.000-00"
                    mask="999.999.999-99"
                />
            )}

            <FkField
                formik={formik}
                name="email"
                label="E-mail"
                required
                type="email"
                sx={{ pl: '44px' }}
                wrap={(body) => <KitInputIco icon={MailIcon}>{body}</KitInputIco>}
            />
            <FkField
                formik={formik}
                name="cell_phone"
                label="Celular"
                required
                type="text"
                inputMode="tel"
                mask="(99) 99999-9999"
                sx={{ pl: '44px' }}
                wrap={(body) => <KitInputIco icon={PhoneIcon}>{body}</KitInputIco>}
            />
            <FkField
                formik={formik}
                name="phone_number"
                label="Telefone"
                type="text"
                inputMode="tel"
                mask="(99) 9999-9999"
                sx={{ pl: '44px' }}
                wrap={(body) => <KitInputIco icon={PhoneIcon}>{body}</KitInputIco>}
            />
            <FkField formik={formik} name="website" label="Site" type="text" inputMode="url" />

            <KitAccordion open={addressOpen} icon={PinIcon} title="Endereço" subtitle="Opcional" onToggle={onToggleAddress}>
                <FkField
                    formik={formik}
                    name="zipcode"
                    label="CEP"
                    type="text"
                    inputMode="numeric"
                    mask="99999-999"
                    onChange={onCepChange}
                />
                {cepStatus !== 'idle' && (
                    <Box sx={{ fontSize: 12, m: '-8px 2px 14px', lineHeight: 1.4, color: cepStatus === 'found' ? 'success.main' : cepStatus === 'notfound' ? 'warning.main' : 'text.disabled', fontWeight: cepStatus === 'loading' ? 400 : 600 }}>
                        {cepStatus === 'loading' && 'Buscando endereço pelo CEP...'}
                        {cepStatus === 'found' && 'Endereço encontrado automaticamente'}
                        {cepStatus === 'notfound' && 'CEP não encontrado — preencha o endereço manualmente'}
                    </Box>
                )}
                <FkField formik={formik} name="address" label="Rua" type="text" />
                <KitGrid2>
                    <FkField formik={formik} name="number_address" label="Número" type="text" inputMode="numeric" />
                    <FkField formik={formik} name="complement" label="Complemento" type="text" />
                </KitGrid2>
                <FkField formik={formik} name="neighborhood" label="Bairro" type="text" />
                <FkField formik={formik} name="city" label="Cidade" type="text" />
            </KitAccordion>

            <KitFormBar>
                <KitButton onClick={onCancel}>Cancelar</KitButton>
                <KitButton variant="primary" onClick={formik.handleSubmit} disabled={loading}>
                    {loading ? 'Salvando...' : 'Salvar'}
                </KitButton>
            </KitFormBar>
        </Box>
    );
}
